"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function useExtraStylesheet(extraStylesheet) {
    react_1.default.useEffect(function () {
        var link;
        if (extraStylesheet) {
            link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = extraStylesheet;
            document.head.appendChild(link);
        }
        return function () {
            if (link) {
                document.head.removeChild(link);
            }
        };
    }, [extraStylesheet]);
}
exports.useExtraStylesheet = useExtraStylesheet;
/**
 * Applies autoplay on the given video element, but only if the screen is wider than the given minWidth
 * Will not load the video on smaller screens
 * @param video
 * @param minWidth
 */
function useVideoAutoplay(video, minWidth) {
    react_1.default.useEffect(function () {
        function handleResize() {
            var _a, _b;
            if (window.innerWidth > minWidth) {
                (_a = video.current) === null || _a === void 0 ? void 0 : _a.setAttribute('autoplay', '');
            }
            else {
                (_b = video.current) === null || _b === void 0 ? void 0 : _b.removeAttribute('autoplay');
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [minWidth, video]);
}
exports.useVideoAutoplay = useVideoAutoplay;
